<template lang="html">

  <section class="aviso-legal">
    <div class="container">
     <h1>AVISO
    LEGAL</h1>
    <p>
      <strong>1.INFORMACIÓN LEGAL Y ACEPTACIÓN
</strong>
    </p>
    <p>
      Estos términos legales regulan el uso del servicio de la página web de MYWORKOUTSTUDIO: www.myworkoutstudio.com  que ponemos a disposición de los usuarios de Internet.
Calle Larra , 19 28004 Madrid, España, y CIF  B- O5321636.
    </p>
    <p>El acceso a la web de MYWORKOUT es gratis salvo por el coste de uso de internet que cada usuario tenga contratado.
    Nuestra web es un canal de comunicación e información para los usuarios de internet, los servicios que ofrece MYWORKOUTSTUDIO
    no se prestan a través de esta página web.
    Todos los usuarios que acceden y navegan por nuestra web, aceptan y se vinculan con las condiciones que establecemos en
    estos Términos Legales, además podríamos cambiarlos en cualquier momento; por lo que te recomendamos leerlos atentamente
    cada vez que lo visites.</p>
    <p><strong>2. PROPIEDAD INTELECTUAL E INDUSTRIAL</strong></p>
<p>
Todos los contenidos de esta web es decir, los textos, imágenes, vídeos, diseño gráfico, código fuente… y la marca,
nombre comercial, logos y signos distintivos…, son propiedad industrial o intelectual de MYWORKOUTSTUDIO o de terceros. Así
que salvo aquellos que resulten estrictamente necesarios para el uso de la web, ninguno de los contenidos de nuestra web
puede entenderse cedido ni a ti ni a terceros, bajo ningún tipo de derecho de explotación.
</p>

<p><strong>3. CONDICIONES DE USO</strong></p>
<p>Simplemente por visitar nuestra web no se entiende que establezcas ningún tipo de relación con MYWORKOUTSTUDIO
Debes usar nuestra página web de manera correcta, de acuerdo con la ley y estos términos legales. Responderás de
cualquier daño y perjuicio que pudieras ocasionar en caso contrario, frente a MYWORKOUTSTUDIO o a terceros. Por ejemplo,
queda prohibido que uses el portal tratando de sobrecargar las redes o nuestros servidores, o tratando de dañar
cualquier equipo informático de MYWORKOUTSTUDIO o de terceros. Queda prohibido que copies, comuniques públicamente o
transformes el contenido de nuestra página, salvo que la ley o MYWORKOUTSTUDIO te lo permitan.</p>
<p>Algunas páginas, como la página de Contacto de nuestra web, contienen un formulario en la que te solicitamos algunos
datos. Aparte de recabar tu consentimiento y aceptación de la Política de Privacidad o las condiciones que sean
aplicables en cada caso, debes completar los datos que te pidamos con información veraz y actualizada. Serás responsable
de cualquier daño o perjuicio que causes a MYWORKOUTSTUDIO o a terceros por información falsa o inexacta que nos facilites.</p>

<p>Por último, si quieres enlazar desde cualquier sitio web a cualquier página de nuestra web, debes tener en cuenta que el
enlace no podrá reproducir nuestra página ni siquiera parcialmente (o sea que no permitimos que se abran “iframes” que
contengan ninguna parte de nuestra web), y que deberá siempre quedar claro la independencia y procedencia de los
contenidos de la web y servicios de MYWORKOUTSTUDIO
no controlamos totalmente, por lo que no nos hacemos responsables de las opiniones que viertan, servicios que presten…
(por favor, avísanos si detectas algún caso de este tipo o que creas que viola tus derechos mandándonos un email a
<a href="mailto:jlcortinap@gmail.com "></a>).</p>
<p><strong>5. PROTECCIÓN DE DATOS PERSONALES</strong></p>
<p>Por favor consulta nuestra Política de Privacidad y nuestra Política de Cookies.
</p>
<p><strong>6. LEGISLACIÓN</strong></p>
<p>Estos términos legales se rigen por la ley española.
</p>

    </p>
   </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'aviso-legal',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.aviso-legal {
  background: url('../../../static/img/bg-politicas.svg');
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 100px 0  100px;
  text-align: left;
  h1{
    margin-bottom: 50px;
        max-width: 200px;
    line-height: 55px;
    @media screen and (max-width:600px){
      font-size: 25px;
      line-height: 26px;
      text-align: right;
      max-width: 100%;;
    }
  }
  a{
    text-decoration: underline;
  }
  p{
    margin:15px 0;
  }
  .container {
    @media screen and(max-width:1470px) {
      width: 100%;
      padding: 0 8vw !important;
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/aviso-legal.vue